import React from 'react';
import ReactDom from 'react-dom';
import styled from 'styled-components';
import Description from './DescriptionComponent';
import KatlaImage from './ImageComponent';

const KatlaColumn = styled.div`
    display:flex;
    height: auto;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;

const StyledImage = styled.div`
    flex: 1;
    overflow: hidden;
`;

export default class KatlaContent extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            text : props.text,
            changing: false
        }

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.text != this.state.text ){

            this.setState( { changing: true }, (  ) => {
                setTimeout( () =>{
                    this.setState({changing:false, text: nextProps.text });
                }, this.props.duration );
            });

        }
        
    }

    render () {

        return (
            
            <KatlaColumn>
                <StyledImage>
                    <KatlaImage duration={300} image={this.props.image} />
                </StyledImage>
                <Description duration={300} text={this.props.text} />
            </KatlaColumn>
            
        )

    }

}